var U = function(t, n) {
  return U = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, i) {
    e.__proto__ = i;
  } || function(e, i) {
    for (var r in i)
      Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
  }, U(t, n);
};
function kt(t, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  U(t, n);
  function e() {
    this.constructor = t;
  }
  t.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
}
function _t(t) {
  var n = typeof Symbol == "function" && Symbol.iterator, e = n && t[n], i = 0;
  if (e)
    return e.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && i >= t.length && (t = void 0), { value: t && t[i++], done: !t };
      }
    };
  throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function At(t) {
  var n;
  g(t, (n = G()) === null || n === void 0 ? void 0 : n.proxy);
}
var j, O = [], pt = (
  /** @class */
  function() {
    function t(n) {
      this.active = !0, this.effects = [], this.cleanups = [], this.vm = n;
    }
    return t.prototype.run = function(n) {
      if (this.active)
        try {
          return this.on(), n();
        } finally {
          this.off();
        }
      else
        process.env.NODE_ENV !== "production" && At("cannot run an inactive effect scope.");
    }, t.prototype.on = function() {
      this.active && (O.push(this), j = this);
    }, t.prototype.off = function() {
      this.active && (O.pop(), j = O[O.length - 1]);
    }, t.prototype.stop = function() {
      this.active && (this.vm.$destroy(), this.effects.forEach(function(n) {
        return n.stop();
      }), this.cleanups.forEach(function(n) {
        return n();
      }), this.active = !1);
    }, t;
  }()
);
(function(t) {
  kt(n, t);
  function n(e) {
    e === void 0 && (e = !1);
    var i = this, r = void 0;
    return Rt(function() {
      r = yt(B());
    }), i = t.call(this, r) || this, e || Pt(i), i;
  }
  return n;
})(pt);
function Pt(t, n) {
  var e;
  if (n = n || j, n && n.active) {
    n.effects.push(t);
    return;
  }
  var i = (e = G()) === null || e === void 0 ? void 0 : e.proxy;
  i && i.$on("hook:destroyed", function() {
    return t.stop();
  });
}
function Tt(t) {
  if (!t.scope) {
    var n = new pt(t.proxy);
    t.scope = n, t.proxy.$on("hook:destroyed", function() {
      return n.stop();
    });
  }
  return t.scope;
}
var q = void 0;
try {
  var S = require("vue");
  S && Q(S) ? q = S : S && "default" in S && Q(S.default) && (q = S.default);
} catch {
}
var E = null, $ = null, N = !0, vt = "__composition_api_installed__";
function Q(t) {
  return t && x(t) && t.name === "Vue";
}
function Dt(t) {
  return E && y(t, vt);
}
function B() {
  return process.env.NODE_ENV !== "production" && X(E, "must call Vue.use(VueCompositionAPI) before using any function."), E;
}
function mt() {
  var t = E || q;
  return process.env.NODE_ENV !== "production" && X(t, "No vue dependency found."), t;
}
function Mt(t) {
  process.env.NODE_ENV !== "production" && E && t.__proto__ !== E.__proto__ && g("[vue-composition-api] another instance of Vue installed"), E = t, Object.defineProperty(t, vt, {
    configurable: !0,
    writable: !0,
    value: !0
  });
}
function Rt(t) {
  var n = N;
  N = !1;
  try {
    t();
  } finally {
    N = n;
  }
}
function Z(t) {
  if (N) {
    var n = $;
    n == null || n.scope.off(), $ = t, $ == null || $.scope.on();
  }
}
function G() {
  return $;
}
var W = /* @__PURE__ */ new WeakMap();
function V(t) {
  if (W.has(t))
    return W.get(t);
  var n = {
    proxy: t,
    update: t.$forceUpdate,
    type: t.$options,
    uid: t._uid,
    // $emit is defined on prototype and it expected to be bound
    emit: t.$emit.bind(t),
    parent: null,
    root: null
    // to be immediately set
  };
  Tt(n);
  var e = [
    "data",
    "props",
    "attrs",
    "refs",
    "vnode",
    "slots"
  ];
  return e.forEach(function(i) {
    v(n, i, {
      get: function() {
        return t["$".concat(i)];
      }
    });
  }), v(n, "isMounted", {
    get: function() {
      return t._isMounted;
    }
  }), v(n, "isUnmounted", {
    get: function() {
      return t._isDestroyed;
    }
  }), v(n, "isDeactivated", {
    get: function() {
      return t._inactive;
    }
  }), v(n, "emitted", {
    get: function() {
      return t._events;
    }
  }), W.set(t, n), t.$parent && (n.parent = V(t.$parent)), t.$root && (n.root = V(t.$root)), n;
}
var Ot = function(t) {
  return Object.prototype.toString.call(t);
};
function tt(t) {
  return typeof t == "function" && /native code/.test(t.toString());
}
var Nt = typeof Symbol < "u" && tt(Symbol) && typeof Reflect < "u" && tt(Reflect.ownKeys), k = function(t) {
  return t;
};
function v(t, n, e) {
  var i = e.get, r = e.set;
  Object.defineProperty(t, n, {
    enumerable: !0,
    configurable: !0,
    get: i || k,
    set: r || k
  });
}
function gt(t, n, e, i) {
  Object.defineProperty(t, n, {
    value: e,
    enumerable: !!i,
    writable: !0,
    configurable: !0
  });
}
function y(t, n) {
  return Object.hasOwnProperty.call(t, n);
}
function X(t, n) {
  if (!t)
    throw new Error("[vue-composition-api] ".concat(n));
}
function Vt(t) {
  return typeof t == "string" || typeof t == "number" || // $flow-disable-line
  typeof t == "symbol" || typeof t == "boolean";
}
function P(t) {
  return Array.isArray(t);
}
var It = 4294967295;
function zt(t) {
  var n = parseFloat(String(t));
  return n >= 0 && Math.floor(n) === n && isFinite(t) && n <= It;
}
function I(t) {
  return t !== null && typeof t == "object";
}
function C(t) {
  return Ot(t) === "[object Object]";
}
function x(t) {
  return typeof t == "function";
}
function Ft(t) {
  return t == null;
}
function g(t, n) {
  var e = mt();
  !e || !e.util ? console.warn("[vue-composition-api] ".concat(t)) : e.util.warn(t, n);
}
function yt(t, n) {
  n === void 0 && (n = {});
  var e = t.config.silent;
  t.config.silent = !0;
  var i = new t(n);
  return t.config.silent = e, i;
}
function Bt(t) {
  var n = B();
  return n && t instanceof n;
}
function Wt(t, n) {
  return function() {
    for (var e = [], i = 0; i < arguments.length; i++)
      e[i] = arguments[i];
    return t.$scopedSlots[n] ? t.$scopedSlots[n].apply(t, e) : process.env.NODE_ENV !== "production" ? g("slots.".concat(n, '() got called outside of the "render()" scope'), t) : void 0;
  };
}
function Lt(t, n) {
  var e;
  if (!t)
    e = {};
  else {
    if (t._normalized)
      return t._normalized;
    e = {};
    for (var i in t)
      t[i] && i[0] !== "$" && (e[i] = !0);
  }
  for (var i in n)
    i in e || (e[i] = !0);
  return e;
}
var M = "composition-api.refKey", et = /* @__PURE__ */ new WeakMap(), Ut = /* @__PURE__ */ new WeakMap();
function jt(t, n, e) {
  var i = B(), r = i.util, a = r.warn, s = r.defineReactive;
  process.env.NODE_ENV !== "production" && (Ft(t) || Vt(t)) && a("Cannot set reactive property on undefined, null, or primitive value: ".concat(t));
  var o = t.__ob__;
  function c() {
    o && I(e) && !y(e, "__ob__") && Y(e);
  }
  if (P(t)) {
    if (zt(n))
      return t.length = Math.max(t.length, n), t.splice(n, 1, e), c(), e;
    if (n === "length" && e !== t.length)
      return t.length = e, o == null || o.dep.notify(), e;
  }
  return n in t && !(n in Object.prototype) ? (t[n] = e, c(), e) : t._isVue || o && o.vmCount ? (process.env.NODE_ENV !== "production" && a("Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option."), e) : o ? (s(o.value, n, e), St(t, n, e), c(), o.dep.notify(), e) : (t[n] = e, e);
}
var bt = (
  /** @class */
  function() {
    function t(n) {
      var e = n.get, i = n.set;
      v(this, "value", {
        get: e,
        set: i
      });
    }
    return t;
  }()
);
function wt(t, n, e) {
  n === void 0 && (n = !1), e === void 0 && (e = !1);
  var i = new bt(t);
  e && (i.effect = !0);
  var r = Object.seal(i);
  return n && Ut.set(r, !0), r;
}
function nt(t) {
  var n;
  if (m(t))
    return t;
  var e = Et((n = {}, n[M] = t, n));
  return wt({
    get: function() {
      return e[M];
    },
    set: function(i) {
      return e[M] = i;
    }
  });
}
function m(t) {
  return t instanceof bt;
}
function qt(t) {
  if (process.env.NODE_ENV !== "production" && !A(t) && g("toRefs() expects a reactive object but received a plain one."), !C(t))
    return t;
  var n = {};
  for (var e in t)
    n[e] = Ht(t, e);
  return n;
}
function Ht(t, n) {
  n in t || jt(t, n, void 0);
  var e = t[n];
  return m(e) ? e : wt({
    get: function() {
      return t[n];
    },
    set: function(i) {
      return t[n] = i;
    }
  });
}
var Ct = "__v_skip";
function T(t) {
  var n;
  return !!(t && y(t, "__ob__") && typeof t.__ob__ == "object" && (!((n = t.__ob__) === null || n === void 0) && n[Ct]));
}
function A(t) {
  var n;
  return !!(t && y(t, "__ob__") && typeof t.__ob__ == "object" && !(!((n = t.__ob__) === null || n === void 0) && n[Ct]));
}
function H(t) {
  if (!(!C(t) || T(t) || P(t) || m(t) || Bt(t) || et.has(t))) {
    et.set(t, !0);
    for (var n = Object.keys(t), e = 0; e < n.length; e++)
      St(t, n[e]);
  }
}
function St(t, n, e) {
  if (n !== "__ob__" && !T(t[n])) {
    var i, r, a = Object.getOwnPropertyDescriptor(t, n);
    if (a) {
      if (a.configurable === !1)
        return;
      i = a.get, r = a.set, (!i || r) && arguments.length === 2 && (e = t[n]);
    }
    H(e), v(t, n, {
      get: function() {
        var o = i ? i.call(t) : e;
        return n !== M && m(o) ? o.value : o;
      },
      set: function(o) {
        i && !r || (n !== M && m(e) && !m(o) ? e.value = o : (r && r.call(t, o), e = o), H(o));
      }
    });
  }
}
function xt(t) {
  var n = mt(), e;
  if (n.observable)
    e = n.observable(t);
  else {
    var i = yt(n, {
      data: {
        $$state: t
      }
    });
    e = i._data.$$state;
  }
  return y(e, "__ob__") || Y(e), e;
}
function Y(t, n) {
  var e, i;
  if (n === void 0 && (n = /* @__PURE__ */ new Set()), !(n.has(t) || y(t, "__ob__") || !Object.isExtensible(t))) {
    gt(t, "__ob__", Kt(t)), n.add(t);
    try {
      for (var r = _t(Object.keys(t)), a = r.next(); !a.done; a = r.next()) {
        var s = a.value, o = t[s];
        !(C(o) || P(o)) || T(o) || !Object.isExtensible(o) || Y(o, n);
      }
    } catch (c) {
      e = { error: c };
    } finally {
      try {
        a && !a.done && (i = r.return) && i.call(r);
      } finally {
        if (e)
          throw e.error;
      }
    }
  }
}
function Kt(t) {
  return t === void 0 && (t = {}), {
    value: t,
    dep: {
      notify: k,
      depend: k,
      addSub: k,
      removeSub: k
    }
  };
}
function Gt() {
  return xt({}).__ob__;
}
function Et(t) {
  if (!I(t))
    return process.env.NODE_ENV !== "production" && g('"reactive()" must be called on an object.'), t;
  if (!(C(t) || P(t)) || T(t) || !Object.isExtensible(t))
    return t;
  var n = xt(t);
  return H(n), n;
}
process.env.NODE_ENV !== "production" && Object.freeze({});
function Xt(t, n, e) {
  var i = t.__composition_api_state__ = t.__composition_api_state__ || {};
  i[n] = e;
}
function Yt(t, n) {
  return (t.__composition_api_state__ || {})[n];
}
var w = {
  set: Xt,
  get: Yt
};
function Jt(t, n, e) {
  var i = t.$options.props;
  !(n in t) && !(i && y(i, n)) ? (m(e) ? v(t, n, {
    get: function() {
      return e.value;
    },
    set: function(r) {
      e.value = r;
    }
  }) : v(t, n, {
    get: function() {
      return A(e) && e.__ob__.dep.depend(), e;
    },
    set: function(r) {
      e = r;
    }
  }), process.env.NODE_ENV !== "production" && t.$nextTick(function() {
    Object.keys(t._data).indexOf(n) === -1 && (m(e) ? v(t._data, n, {
      get: function() {
        return e.value;
      },
      set: function(r) {
        e.value = r;
      }
    }) : v(t._data, n, {
      get: function() {
        return e;
      },
      set: function(r) {
        e = r;
      }
    }));
  })) : process.env.NODE_ENV !== "production" && (i && y(i, n) ? g('The setup binding property "'.concat(n, '" is already declared as a prop.'), t) : g('The setup binding property "'.concat(n, '" is already declared.'), t));
}
function Qt(t) {
  var n = w.get(t, "rawBindings") || {};
  if (!(!n || !Object.keys(n).length)) {
    for (var e = t.$refs, i = w.get(t, "refs") || [], r = 0; r < i.length; r++) {
      var a = i[r], s = n[a];
      !e[a] && s && m(s) && (s.value = null);
    }
    for (var o = Object.keys(e), c = [], r = 0; r < o.length; r++) {
      var a = o[r], s = n[a];
      e[a] && s && m(s) && (s.value = e[a], c.push(a));
    }
    w.set(t, "refs", c);
  }
}
function it(t) {
  for (var n = [t._vnode]; n.length; ) {
    var e = n.pop();
    if (e && (e.context && Qt(e.context), e.children))
      for (var i = 0; i < e.children.length; ++i)
        n.push(e.children[i]);
  }
}
function rt(t, n) {
  var e, i;
  if (t) {
    var r = w.get(t, "attrBindings");
    if (!(!r && !n)) {
      if (!r) {
        var a = Et({});
        r = { ctx: n, data: a }, w.set(t, "attrBindings", r), v(n, "attrs", {
          get: function() {
            return r == null ? void 0 : r.data;
          },
          set: function() {
            process.env.NODE_ENV !== "production" && g("Cannot assign to '$attrs' because it is a read-only property", t);
          }
        });
      }
      var s = t.$attrs, o = function(d) {
        y(r.data, d) || v(r.data, d, {
          get: function() {
            return t.$attrs[d];
          }
        });
      };
      try {
        for (var c = _t(Object.keys(s)), l = c.next(); !l.done; l = c.next()) {
          var u = l.value;
          o(u);
        }
      } catch (d) {
        e = { error: d };
      } finally {
        try {
          l && !l.done && (i = c.return) && i.call(c);
        } finally {
          if (e)
            throw e.error;
        }
      }
    }
  }
}
function st(t, n) {
  var e = t.$options._parentVnode;
  if (e) {
    for (var i = w.get(t, "slots") || [], r = Lt(e.data.scopedSlots, t.$slots), a = 0; a < i.length; a++) {
      var s = i[a];
      r[s] || delete n[s];
    }
    for (var o = Object.keys(r), a = 0; a < o.length; a++) {
      var s = o[a];
      n[s] || (n[s] = Wt(t, s));
    }
    w.set(t, "slots", o);
  }
}
function L(t, n, e) {
  var i = G();
  Z(t);
  try {
    return n(t);
  } catch (r) {
    if (e)
      e(r);
    else
      throw r;
  } finally {
    Z(i);
  }
}
function Zt(t) {
  t.mixin({
    beforeCreate: n,
    mounted: function() {
      it(this);
    },
    beforeUpdate: function() {
      rt(this);
    },
    updated: function() {
      it(this);
    }
  });
  function n() {
    var s = this, o = s.$options, c = o.setup, l = o.render;
    if (l && (o.render = function() {
      for (var d = this, f = [], p = 0; p < arguments.length; p++)
        f[p] = arguments[p];
      return L(V(s), function() {
        return l.apply(d, f);
      });
    }), !!c) {
      if (!x(c)) {
        process.env.NODE_ENV !== "production" && g('The "setup" option should be a function that returns a object in component definitions.', s);
        return;
      }
      var u = o.data;
      o.data = function() {
        return e(s, s.$props), x(u) ? u.call(s, s) : u || {};
      };
    }
  }
  function e(s, o) {
    o === void 0 && (o = {});
    var c = s.$options.setup, l = a(s), u = V(s);
    u.setupContext = l, gt(o, "__ob__", Gt()), st(s, l.slots);
    var d;
    if (L(u, function() {
      d = c(o, l);
    }), !!d) {
      if (x(d)) {
        var f = d;
        s.$options.render = function() {
          return st(s, l.slots), L(u, function() {
            return f();
          });
        };
        return;
      } else if (I(d)) {
        A(d) && (d = qt(d)), w.set(s, "rawBindings", d);
        var p = d;
        Object.keys(p).forEach(function(_) {
          var h = p[_];
          if (!m(h))
            if (A(h))
              P(h) && (h = nt(h));
            else if (x(h)) {
              var b = h;
              h = h.bind(s), Object.keys(b).forEach(function(D) {
                h[D] = b[D];
              });
            } else
              I(h) ? r(h) && i(h) : h = nt(h);
          Jt(s, _, h);
        });
        return;
      }
      process.env.NODE_ENV !== "production" && X(!1, '"setup" must return a "Object" or a "Function", got "'.concat(Object.prototype.toString.call(d).slice(8, -1), '"'));
    }
  }
  function i(s, o) {
    if (o === void 0 && (o = /* @__PURE__ */ new Set()), !o.has(s) && !(!C(s) || m(s) || A(s) || T(s))) {
      var c = B(), l = c.util.defineReactive;
      Object.keys(s).forEach(function(u) {
        var d = s[u];
        l(s, u, d), d && (o.add(d), i(d, o));
      });
    }
  }
  function r(s, o) {
    return o === void 0 && (o = /* @__PURE__ */ new Map()), o.has(s) ? o.get(s) : (o.set(s, !1), P(s) && A(s) ? (o.set(s, !0), !0) : !C(s) || T(s) || m(s) ? !1 : Object.keys(s).some(function(c) {
      return r(s[c], o);
    }));
  }
  function a(s) {
    var o = { slots: {} }, c = [
      "root",
      "parent",
      "refs",
      "listeners",
      "isServer",
      "ssrContext"
    ], l = ["emit"];
    return c.forEach(function(u) {
      var d = "$".concat(u);
      v(o, u, {
        get: function() {
          return s[d];
        },
        set: function() {
          process.env.NODE_ENV !== "production" && g("Cannot assign to '".concat(u, "' because it is a read-only property"), s);
        }
      });
    }), rt(s, o), l.forEach(function(u) {
      var d = "$".concat(u);
      v(o, u, {
        get: function() {
          return function() {
            for (var f = [], p = 0; p < arguments.length; p++)
              f[p] = arguments[p];
            var _ = s[d];
            _.apply(s, f);
          };
        }
      });
    }), process.env.NODE_ENV === "test" && (o._vm = s), o;
  }
}
function $t(t, n) {
  if (!t)
    return n;
  if (!n)
    return t;
  for (var e, i, r, a = Nt ? Reflect.ownKeys(t) : Object.keys(t), s = 0; s < a.length; s++)
    e = a[s], e !== "__ob__" && (i = n[e], r = t[e], y(n, e) ? i !== r && C(i) && !m(i) && C(r) && !m(r) && $t(r, i) : n[e] = r);
  return n;
}
function te(t) {
  if (Dt(t)) {
    process.env.NODE_ENV !== "production" && g("[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.");
    return;
  }
  process.env.NODE_ENV !== "production" && (t.version ? (t.version[0] !== "2" || t.version[1] !== ".") && g("[vue-composition-api] only works with Vue 2, v".concat(t.version, " found.")) : g("[vue-composition-api] no Vue version found")), t.config.optionMergeStrategies.setup = function(n, e) {
    return function(r, a) {
      return $t(x(n) ? n(r, a) || {} : void 0, x(e) ? e(r, a) || {} : void 0);
    };
  }, Mt(t), Zt(t);
}
var ee = {
  install: function(t) {
    return te(t);
  }
};
typeof window < "u" && window.Vue && window.Vue.use(ee);
/*!
 * Signature Pad v3.0.0-beta.4 | https://github.com/szimek/signature_pad
 * (c) 2020 Szymon Nowak | Released under the MIT license
 */
class z {
  constructor(n, e, i) {
    this.x = n, this.y = e, this.time = i || Date.now();
  }
  distanceTo(n) {
    return Math.sqrt(Math.pow(this.x - n.x, 2) + Math.pow(this.y - n.y, 2));
  }
  equals(n) {
    return this.x === n.x && this.y === n.y && this.time === n.time;
  }
  velocityFrom(n) {
    return this.time !== n.time ? this.distanceTo(n) / (this.time - n.time) : 0;
  }
}
class J {
  constructor(n, e, i, r, a, s) {
    this.startPoint = n, this.control2 = e, this.control1 = i, this.endPoint = r, this.startWidth = a, this.endWidth = s;
  }
  static fromPoints(n, e) {
    const i = this.calculateControlPoints(n[0], n[1], n[2]).c2, r = this.calculateControlPoints(n[1], n[2], n[3]).c1;
    return new J(n[1], i, r, n[2], e.start, e.end);
  }
  static calculateControlPoints(n, e, i) {
    const r = n.x - e.x, a = n.y - e.y, s = e.x - i.x, o = e.y - i.y, c = { x: (n.x + e.x) / 2, y: (n.y + e.y) / 2 }, l = { x: (e.x + i.x) / 2, y: (e.y + i.y) / 2 }, u = Math.sqrt(r * r + a * a), d = Math.sqrt(s * s + o * o), f = c.x - l.x, p = c.y - l.y, _ = d / (u + d), h = { x: l.x + f * _, y: l.y + p * _ }, b = e.x - h.x, D = e.y - h.y;
    return {
      c1: new z(c.x + b, c.y + D),
      c2: new z(l.x + b, l.y + D)
    };
  }
  length() {
    let e = 0, i, r;
    for (let a = 0; a <= 10; a += 1) {
      const s = a / 10, o = this.point(s, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), c = this.point(s, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (a > 0) {
        const l = o - i, u = c - r;
        e += Math.sqrt(l * l + u * u);
      }
      i = o, r = c;
    }
    return e;
  }
  point(n, e, i, r, a) {
    return e * (1 - n) * (1 - n) * (1 - n) + 3 * i * (1 - n) * (1 - n) * n + 3 * r * (1 - n) * n * n + a * n * n * n;
  }
}
function ne(t, n = 250) {
  let e = 0, i = null, r, a, s;
  const o = () => {
    e = Date.now(), i = null, r = t.apply(a, s), i || (a = null, s = []);
  };
  return function(...l) {
    const u = Date.now(), d = n - (u - e);
    return a = this, s = l, d <= 0 || d > n ? (i && (clearTimeout(i), i = null), e = u, r = t.apply(a, s), i || (a = null, s = [])) : i || (i = window.setTimeout(o, d)), r;
  };
}
class F {
  constructor(n, e = {}) {
    this.canvas = n, this.options = e, this._handleMouseDown = (i) => {
      i.which === 1 && (this._mouseButtonDown = !0, this._strokeBegin(i));
    }, this._handleMouseMove = (i) => {
      this._mouseButtonDown && this._strokeMoveUpdate(i);
    }, this._handleMouseUp = (i) => {
      i.which === 1 && this._mouseButtonDown && (this._mouseButtonDown = !1, this._strokeEnd(i));
    }, this._handleTouchStart = (i) => {
      if (i.preventDefault(), i.targetTouches.length === 1) {
        const r = i.changedTouches[0];
        this._strokeBegin(r);
      }
    }, this._handleTouchMove = (i) => {
      i.preventDefault();
      const r = i.targetTouches[0];
      this._strokeMoveUpdate(r);
    }, this._handleTouchEnd = (i) => {
      if (i.target === this.canvas) {
        i.preventDefault();
        const a = i.changedTouches[0];
        this._strokeEnd(a);
      }
    }, this.velocityFilterWeight = e.velocityFilterWeight || 0.7, this.minWidth = e.minWidth || 0.5, this.maxWidth = e.maxWidth || 2.5, this.throttle = "throttle" in e ? e.throttle : 16, this.minDistance = "minDistance" in e ? e.minDistance : 5, this.dotSize = e.dotSize || function() {
      return (this.minWidth + this.maxWidth) / 2;
    }, this.penColor = e.penColor || "black", this.backgroundColor = e.backgroundColor || "rgba(0,0,0,0)", this.onBegin = e.onBegin, this.onEnd = e.onEnd, this._strokeMoveUpdate = this.throttle ? ne(F.prototype._strokeUpdate, this.throttle) : F.prototype._strokeUpdate, this._ctx = n.getContext("2d"), this.clear(), this.on();
  }
  clear() {
    const { _ctx: n, canvas: e } = this;
    n.fillStyle = this.backgroundColor, n.clearRect(0, 0, e.width, e.height), n.fillRect(0, 0, e.width, e.height), this._data = [], this._reset(), this._isEmpty = !0;
  }
  fromDataURL(n, e = {}, i) {
    const r = new Image(), a = e.ratio || window.devicePixelRatio || 1, s = e.width || this.canvas.width / a, o = e.height || this.canvas.height / a;
    this._reset(), r.onload = () => {
      this._ctx.drawImage(r, 0, 0, s, o), i && i();
    }, r.onerror = (c) => {
      i && i(c);
    }, r.src = n, this._isEmpty = !1;
  }
  toDataURL(n = "image/png", e) {
    switch (n) {
      case "image/svg+xml":
        return this._toSVG();
      default:
        return this.canvas.toDataURL(n, e);
    }
  }
  on() {
    this.canvas.style.touchAction = "none", this.canvas.style.msTouchAction = "none", window.PointerEvent ? this._handlePointerEvents() : (this._handleMouseEvents(), "ontouchstart" in window && this._handleTouchEvents());
  }
  off() {
    this.canvas.style.touchAction = "auto", this.canvas.style.msTouchAction = "auto", this.canvas.removeEventListener("pointerdown", this._handleMouseDown), this.canvas.removeEventListener("pointermove", this._handleMouseMove), document.removeEventListener("pointerup", this._handleMouseUp), this.canvas.removeEventListener("mousedown", this._handleMouseDown), this.canvas.removeEventListener("mousemove", this._handleMouseMove), document.removeEventListener("mouseup", this._handleMouseUp), this.canvas.removeEventListener("touchstart", this._handleTouchStart), this.canvas.removeEventListener("touchmove", this._handleTouchMove), this.canvas.removeEventListener("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(n) {
    this.clear(), this._fromData(n, ({ color: e, curve: i }) => this._drawCurve({ color: e, curve: i }), ({ color: e, point: i }) => this._drawDot({ color: e, point: i })), this._data = n;
  }
  toData() {
    return this._data;
  }
  _strokeBegin(n) {
    const e = {
      color: this.penColor,
      points: []
    };
    typeof this.onBegin == "function" && this.onBegin(n), this._data.push(e), this._reset(), this._strokeUpdate(n);
  }
  _strokeUpdate(n) {
    if (this._data.length === 0) {
      this._strokeBegin(n);
      return;
    }
    const e = n.clientX, i = n.clientY, r = this._createPoint(e, i), a = this._data[this._data.length - 1], s = a.points, o = s.length > 0 && s[s.length - 1], c = o ? r.distanceTo(o) <= this.minDistance : !1, l = a.color;
    if (!o || !(o && c)) {
      const u = this._addPoint(r);
      o ? u && this._drawCurve({ color: l, curve: u }) : this._drawDot({ color: l, point: r }), s.push({
        time: r.time,
        x: r.x,
        y: r.y
      });
    }
  }
  _strokeEnd(n) {
    this._strokeUpdate(n), typeof this.onEnd == "function" && this.onEnd(n);
  }
  _handlePointerEvents() {
    this._mouseButtonDown = !1, this.canvas.addEventListener("pointerdown", this._handleMouseDown), this.canvas.addEventListener("pointermove", this._handleMouseMove), document.addEventListener("pointerup", this._handleMouseUp);
  }
  _handleMouseEvents() {
    this._mouseButtonDown = !1, this.canvas.addEventListener("mousedown", this._handleMouseDown), this.canvas.addEventListener("mousemove", this._handleMouseMove), document.addEventListener("mouseup", this._handleMouseUp);
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart), this.canvas.addEventListener("touchmove", this._handleTouchMove), this.canvas.addEventListener("touchend", this._handleTouchEnd);
  }
  _reset() {
    this._lastPoints = [], this._lastVelocity = 0, this._lastWidth = (this.minWidth + this.maxWidth) / 2, this._ctx.fillStyle = this.penColor;
  }
  _createPoint(n, e) {
    const i = this.canvas.getBoundingClientRect();
    return new z(n - i.left, e - i.top, (/* @__PURE__ */ new Date()).getTime());
  }
  _addPoint(n) {
    const { _lastPoints: e } = this;
    if (e.push(n), e.length > 2) {
      e.length === 3 && e.unshift(e[0]);
      const i = this._calculateCurveWidths(e[1], e[2]), r = J.fromPoints(e, i);
      return e.shift(), r;
    }
    return null;
  }
  _calculateCurveWidths(n, e) {
    const i = this.velocityFilterWeight * e.velocityFrom(n) + (1 - this.velocityFilterWeight) * this._lastVelocity, r = this._strokeWidth(i), a = {
      end: r,
      start: this._lastWidth
    };
    return this._lastVelocity = i, this._lastWidth = r, a;
  }
  _strokeWidth(n) {
    return Math.max(this.maxWidth / (n + 1), this.minWidth);
  }
  _drawCurveSegment(n, e, i) {
    const r = this._ctx;
    r.moveTo(n, e), r.arc(n, e, i, 0, 2 * Math.PI, !1), this._isEmpty = !1;
  }
  _drawCurve({ color: n, curve: e }) {
    const i = this._ctx, r = e.endWidth - e.startWidth, a = Math.floor(e.length()) * 2;
    i.beginPath(), i.fillStyle = n;
    for (let s = 0; s < a; s += 1) {
      const o = s / a, c = o * o, l = c * o, u = 1 - o, d = u * u, f = d * u;
      let p = f * e.startPoint.x;
      p += 3 * d * o * e.control1.x, p += 3 * u * c * e.control2.x, p += l * e.endPoint.x;
      let _ = f * e.startPoint.y;
      _ += 3 * d * o * e.control1.y, _ += 3 * u * c * e.control2.y, _ += l * e.endPoint.y;
      const h = Math.min(e.startWidth + l * r, this.maxWidth);
      this._drawCurveSegment(p, _, h);
    }
    i.closePath(), i.fill();
  }
  _drawDot({ color: n, point: e }) {
    const i = this._ctx, r = typeof this.dotSize == "function" ? this.dotSize() : this.dotSize;
    i.beginPath(), this._drawCurveSegment(e.x, e.y, r), i.closePath(), i.fillStyle = n, i.fill();
  }
  _fromData(n, e, i) {
    for (const r of n) {
      const { color: a, points: s } = r;
      if (s.length > 1)
        for (let o = 0; o < s.length; o += 1) {
          const c = s[o], l = new z(c.x, c.y, c.time);
          this.penColor = a, o === 0 && this._reset();
          const u = this._addPoint(l);
          u && e({ color: a, curve: u });
        }
      else
        this._reset(), i({
          color: a,
          point: s[0]
        });
    }
  }
  _toSVG() {
    const n = this._data, e = Math.max(window.devicePixelRatio || 1, 1), i = 0, r = 0, a = this.canvas.width / e, s = this.canvas.height / e, o = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    o.setAttribute("width", this.canvas.width.toString()), o.setAttribute("height", this.canvas.height.toString()), this._fromData(n, ({ color: p, curve: _ }) => {
      const h = document.createElement("path");
      if (!isNaN(_.control1.x) && !isNaN(_.control1.y) && !isNaN(_.control2.x) && !isNaN(_.control2.y)) {
        const b = `M ${_.startPoint.x.toFixed(3)},${_.startPoint.y.toFixed(3)} C ${_.control1.x.toFixed(3)},${_.control1.y.toFixed(3)} ${_.control2.x.toFixed(3)},${_.control2.y.toFixed(3)} ${_.endPoint.x.toFixed(3)},${_.endPoint.y.toFixed(3)}`;
        h.setAttribute("d", b), h.setAttribute("stroke-width", (_.endWidth * 2.25).toFixed(3)), h.setAttribute("stroke", p), h.setAttribute("fill", "none"), h.setAttribute("stroke-linecap", "round"), o.appendChild(h);
      }
    }, ({ color: p, point: _ }) => {
      const h = document.createElement("circle"), b = typeof this.dotSize == "function" ? this.dotSize() : this.dotSize;
      h.setAttribute("r", b.toString()), h.setAttribute("cx", _.x.toString()), h.setAttribute("cy", _.y.toString()), h.setAttribute("fill", p), o.appendChild(h);
    });
    const c = "data:image/svg+xml;base64,", l = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="${i} ${r} ${a} ${s}" width="${a}" height="${s}">`;
    let u = o.innerHTML;
    if (u === void 0) {
      const p = document.createElement("dummy"), _ = o.childNodes;
      p.innerHTML = "";
      for (let h = 0; h < _.length; h += 1)
        p.appendChild(_[h].cloneNode(!0));
      u = p.innerHTML;
    }
    const d = "</svg>", f = l + u + d;
    return c + btoa(f);
  }
}
var ie = {
  format: "image/png",
  quality: 0.92,
  width: void 0,
  height: void 0,
  Canvas: void 0,
  crossOrigin: void 0
}, ot = function(t, n) {
  return t === void 0 && (t = []), n === void 0 && (n = {}), new Promise(function(e) {
    n = Object.assign({}, ie, n);
    var i = n.Canvas ? new n.Canvas() : window.document.createElement("canvas"), r = n.Canvas ? n.Canvas.Image : window.Image;
    n.Canvas && (n.quality *= 100);
    var a = t.map(function(o) {
      return new Promise(function(c, l) {
        o.constructor.name !== "Object" && (o = { src: o });
        var u = new r();
        u.crossOrigin = n.crossOrigin, u.onerror = function() {
          return l(new Error("Couldn't load image"));
        }, u.onload = function() {
          return c(Object.assign({}, o, { img: u }));
        }, u.src = o.src;
      });
    }), s = i.getContext("2d");
    e(Promise.all(a).then(function(o) {
      var c = function(l) {
        return n[l] || Math.max.apply(Math, o.map(function(u) {
          return u.img[l];
        }));
      };
      return i.width = c("width"), i.height = c("height"), o.forEach(function(l) {
        return s.globalAlpha = l.opacity ? l.opacity : 1, s.drawImage(l.img, l.x || 0, l.y || 0);
      }), n.Canvas && n.format === "image/jpeg" ? new Promise(function(l) {
        i.toDataURL(n.format, {
          quality: n.quality,
          progressive: !1
        }, function(u, d) {
          if (u)
            throw u;
          l(d);
        });
      }) : i.toDataURL(n.format, n.quality);
    }));
  });
};
const K = ["image/png", "image/jpeg", "image/svg+xml"], re = (t) => K.includes(t), se = {
  dotSize: (0.5 + 2.5) / 2,
  minWidth: 0.5,
  maxWidth: 2.5,
  throttle: 16,
  minDistance: 5,
  backgroundColor: "rgba(0,0,0,0)",
  penColor: "black",
  velocityFilterWeight: 0.7,
  onBegin: () => {
  },
  onEnd: () => {
  }
}, at = (t) => JSON.parse(JSON.stringify(t)), ct = {
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
  x: 0,
  y: 0
};
var oe = {
  name: "VueSignaturePad",
  props: {
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    },
    images: {
      type: Array,
      default: () => []
    },
    scaleToDevicePixelRatio: {
      type: Boolean,
      default: () => !0
    }
  },
  data: () => ({
    signaturePad: {},
    cacheImages: [],
    signatureData: ct,
    onResizeHandler: null
  }),
  computed: {
    propsImagesAndCustomImages() {
      const t = at(this.images), n = at(this.cacheImages);
      return [...t, ...n];
    }
  },
  watch: {
    options: function(t) {
      Object.keys(t).forEach((n) => {
        this.signaturePad[n] && (this.signaturePad[n] = t[n]);
      });
    }
  },
  mounted() {
    const {
      options: t
    } = this, n = this.$refs.signaturePadCanvas, e = new F(n, {
      ...se,
      ...t
    });
    this.signaturePad = e, t.resizeHandler && (this.resizeCanvas = t.resizeHandler.bind(this)), this.onResizeHandler = this.resizeCanvas.bind(this), window.addEventListener("resize", this.onResizeHandler, !1), this.resizeCanvas();
  },
  beforeDestroy() {
    this.onResizeHandler && window.removeEventListener("resize", this.onResizeHandler, !1);
  },
  methods: {
    resizeCanvas() {
      const t = this.$refs.signaturePadCanvas, n = this.signaturePad.toData(), e = this.scaleToDevicePixelRatio ? Math.max(window.devicePixelRatio || 1, 1) : 1;
      t.width = t.offsetWidth * e, t.height = t.offsetHeight * e, t.getContext("2d").scale(e, e), this.signaturePad.clear(), this.signatureData = ct, this.signaturePad.fromData(n);
    },
    saveSignature(t = K[0], n) {
      const {
        signaturePad: e
      } = this, i = {
        isEmpty: !1,
        data: void 0
      };
      if (!re(t)) {
        const r = K.join(", ");
        throw new Error(`The Image type is incorrect! We are support ${r} types.`);
      }
      return e.isEmpty() ? {
        ...i,
        isEmpty: !0
      } : (this.signatureData = e.toDataURL(t, n), {
        ...i,
        data: this.signatureData
      });
    },
    undoSignature() {
      const {
        signaturePad: t
      } = this, n = t.toData();
      if (n)
        return t.fromData(n.slice(0, -1));
    },
    mergeImageAndSignature(t) {
      return this.signatureData = t, ot([...this.images, ...this.cacheImages, this.signatureData]);
    },
    addImages(t = []) {
      return this.cacheImages = [...this.cacheImages, ...t], ot([...this.images, ...this.cacheImages, this.signatureData]);
    },
    fromDataURL(t, n = {}, e) {
      return this.signaturePad.fromDataURL(t, n, e);
    },
    fromData(t) {
      return this.signaturePad.fromData(t);
    },
    toData() {
      return this.signaturePad.toData();
    },
    lockSignaturePad() {
      return this.signaturePad.off();
    },
    openSignaturePad() {
      return this.signaturePad.on();
    },
    isEmpty() {
      return this.signaturePad.isEmpty();
    },
    getPropImagesAndCacheImages() {
      return this.propsImagesAndCustomImages;
    },
    clearCacheImages() {
      return this.cacheImages = [], this.cacheImages;
    },
    clearSignature() {
      return this.signaturePad.clear();
    }
  },
  render(t) {
    const {
      width: n,
      height: e,
      customStyle: i
    } = this;
    return t("div", {
      style: {
        width: n,
        height: e,
        ...i
      }
    }, [t("canvas", {
      style: {
        width: n,
        height: e
      },
      ref: "signaturePadCanvas"
    })]);
  }
};
function ae(t, n, e, i, r, a, s, o, c, l) {
  typeof s != "boolean" && (c = o, o = s, s = !1);
  const u = typeof e == "function" ? e.options : e;
  t && t.render && (u.render = t.render, u.staticRenderFns = t.staticRenderFns, u._compiled = !0, r && (u.functional = !0)), i && (u._scopeId = i);
  let d;
  if (a ? (d = function(f) {
    f = f || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !f && typeof __VUE_SSR_CONTEXT__ < "u" && (f = __VUE_SSR_CONTEXT__), n && n.call(this, c(f)), f && f._registeredComponents && f._registeredComponents.add(a);
  }, u._ssrRegister = d) : n && (d = s ? function(f) {
    n.call(this, l(f, this.$root.$options.shadowRoot));
  } : function(f) {
    n.call(this, o(f));
  }), d)
    if (u.functional) {
      const f = u.render;
      u.render = function(_, h) {
        return d.call(h), f(_, h);
      };
    } else {
      const f = u.beforeCreate;
      u.beforeCreate = f ? [].concat(f, d) : [d];
    }
  return e;
}
const ce = oe, ue = void 0, le = void 0, de = void 0, fe = void 0, he = /* @__PURE__ */ ae({}, ue, ce, le, fe, de, !1, void 0, void 0, void 0), _e = {
  name: "FaSolidEye"
};
var pe = function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1.13em",
      height: "1em",
      viewBox: "0 0 576 512"
    }
  }, [e("path", {
    attrs: {
      fill: "currentColor",
      d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144a143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79a47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    }
  })]);
}, ve = [];
function R(t, n, e, i, r, a, s, o) {
  var c = typeof t == "function" ? t.options : t;
  n && (c.render = n, c.staticRenderFns = e, c._compiled = !0), i && (c.functional = !0), a && (c._scopeId = "data-v-" + a);
  var l;
  if (s ? (l = function(f) {
    f = f || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !f && typeof __VUE_SSR_CONTEXT__ < "u" && (f = __VUE_SSR_CONTEXT__), r && r.call(this, f), f && f._registeredComponents && f._registeredComponents.add(s);
  }, c._ssrRegister = l) : r && (l = o ? function() {
    r.call(
      this,
      (c.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : r), l)
    if (c.functional) {
      c._injectStyles = l;
      var u = c.render;
      c.render = function(p, _) {
        return l.call(_), u(p, _);
      };
    } else {
      var d = c.beforeCreate;
      c.beforeCreate = d ? [].concat(d, l) : [l];
    }
  return {
    exports: t,
    options: c
  };
}
const ut = {};
var me = /* @__PURE__ */ R(
  _e,
  pe,
  ve,
  !1,
  ge,
  null,
  null,
  null
);
function ge(t) {
  for (let n in ut)
    this[n] = ut[n];
}
const ye = /* @__PURE__ */ function() {
  return me.exports;
}(), be = {
  name: "FaRegularSquare"
};
var we = function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "0.88em",
      height: "1em",
      viewBox: "0 0 448 512"
    }
  }, [e("path", {
    attrs: {
      fill: "currentColor",
      d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
    }
  })]);
}, Ce = [];
const lt = {};
var Se = /* @__PURE__ */ R(
  be,
  we,
  Ce,
  !1,
  xe,
  null,
  null,
  null
);
function xe(t) {
  for (let n in lt)
    this[n] = lt[n];
}
const Ee = /* @__PURE__ */ function() {
  return Se.exports;
}(), $e = {
  name: "FaRegularCheckSquare"
};
var ke = function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "0.88em",
      height: "1em",
      viewBox: "0 0 448 512"
    }
  }, [e("path", {
    attrs: {
      fill: "currentColor",
      d: "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277l141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
    }
  })]);
}, Ae = [];
const dt = {};
var Pe = /* @__PURE__ */ R(
  $e,
  ke,
  Ae,
  !1,
  Te,
  null,
  null,
  null
);
function Te(t) {
  for (let n in dt)
    this[n] = dt[n];
}
const De = /* @__PURE__ */ function() {
  return Pe.exports;
}(), Me = {
  name: "FaSolidEraser"
};
var Re = function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      viewBox: "0 0 512 512"
    }
  }, [e("path", {
    attrs: {
      fill: "currentColor",
      d: "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80l124.686-124.686z"
    }
  })]);
}, Oe = [];
const ft = {};
var Ne = /* @__PURE__ */ R(
  Me,
  Re,
  Oe,
  !1,
  Ve,
  null,
  null,
  null
);
function Ve(t) {
  for (let n in ft)
    this[n] = ft[n];
}
const Ie = /* @__PURE__ */ function() {
  return Ne.exports;
}(), ze = {
  name: "ExaSignature",
  props: {
    user: Object,
    withConfirmationAccord: Boolean,
    withTokenSMS: Boolean,
    typeToken: Array,
    // 'mail', 'sms'
    withValidation: Boolean,
    disabledButton: Boolean
  },
  emits: [
    "signWithCertificat",
    "errorSignature",
    "saveSignature",
    "valideSignatureContrat",
    "saveToken"
  ],
  setup(t) {
    t.user, t.withConfirmationAccord, t.withTokenSMS, t.typeToken, t.withValidation, t.disabledButton;
  },
  components: {
    VueSignaturePad: he,
    FaSolidEye: ye,
    FaRegularSquare: Ee,
    FaRegularCheckSquare: De,
    FaSolidEraser: Ie
  },
  data: () => ({
    confirmationAccord: !1,
    etapeDessin: !0,
    etapeSelectionSupport: !1,
    dessinSignature: "",
    mode_reception: "option_sms",
    etapeToken: !1,
    etapeValidation: !1,
    tokenSMS: ""
  }),
  computed: {
    confirmationAlertStyle() {
      return this.confirmationAccord ? "success" : "secondary";
    }
  },
  methods: {
    confirmerAccord(t) {
      this.confirmationAccord = t;
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature() {
      if (this.$emit("errorSignature", ""), this.$refs.signaturePad) {
        const { isEmpty: t, data: n } = this.$refs.signaturePad.saveSignature();
        if (t)
          this.$emit(
            "errorSignature",
            "La signature est vide. Merci de recommencer votre dessin."
          );
        else {
          const e = this.$refs.signaturePad.toData();
          let i = 0, r = 0, a = 0;
          for (const s in e)
            i++, r += e[s].points.length, a < e[s].points.length && (a = e[s].points.length);
          i >= 1 && a >= 3 && r >= 4 ? (this.dessinSignature = n, this.withTokenSMS && (!this.typeToken || this.typeToken.length === 0 || this.typeToken.includes("sms") && this.typeToken.includes("mail")) ? (this.etapeSelectionSupport = !0, this.etapeDessin = !1, this.$emit("errorSignature", "")) : this.withTokenSMS && this.typeToken && this.typeToken.length === 1 && this.typeToken.includes("mail") ? (this.etapeSelectionSupport = !0, this.etapeDessin = !1, this.mode_reception = "option_email", this.$emit("errorSignature", "")) : this.withTokenSMS && this.typeToken && this.typeToken.length === 1 && this.typeToken.includes("sms") ? (this.etapeSelectionSupport = !0, this.etapeDessin = !1, this.mode_reception = "option_sms", this.$emit("errorSignature", "")) : this.validationContrat()) : this.$emit(
            "errorSignature",
            "Le dessin de la signature est invalide. Merci de recommencer."
          );
        }
      }
    },
    checkHasDossierAdministratif() {
      var t, n;
      return (n = (t = this.user) == null ? void 0 : t.abilities) == null ? void 0 : n.some((e) => (this.withTokenSMS && this.typeToken && this.typeToken.length === 1 && this.typeToken.includes("mail") ? this.mode_reception = "option_email" : this.withTokenSMS && this.typeToken && this.typeToken.length === 1 && this.typeToken.includes("sms") && (this.mode_reception = "option_sms"), e.entity_type === "App\\Models\\DossierAdministratif"));
    },
    confirmerModeReception() {
      this.etapeSelectionSupport = !1, this.etapeToken = !0;
      let t = "";
      this.mode_reception === "option_email" ? t = "mail" : this.mode_reception === "option_sms" && (t = "sms"), this.$emit("saveSignature", {
        signature: this.dessinSignature,
        mode: t
      }), this.$emit("errorSignature", "");
    },
    saveWithToken() {
      this.tokenSMS !== "" ? this.withValidation ? (this.$emit("errorSignature", ""), this.etapeToken = !1, this.etapeDessin = !1, this.etapeValidation = !0) : (this.$emit("saveToken", this.tokenSMS), this.$emit("errorSignature", ""), this.etapeDessin = !1) : this.$emit("errorSignature", "Le code de sécurité renseigné est vide.");
    },
    validationContrat() {
      this.$emit("valideSignatureContrat"), this.$emit("errorSignature", "");
    },
    signatureCertificat() {
      this.$emit("signWithCertificat"), this.$emit("errorSignature", "");
    }
  }
};
var Fe = function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    attrs: {
      id: "signature_document"
    }
  }, [t.withConfirmationAccord ? e("div", {
    staticClass: "mb-4",
    attrs: {
      id: "bloc_confirmationAccord"
    }
  }, [e("div", {
    staticClass: "alert ps-2 py-1 mb-3",
    class: `alert-${t.confirmationAlertStyle}`
  }, [e("div", {
    staticClass: "row align-items-center"
  }, [e("div", {
    staticClass: "col-xl-2 col-2"
  }, [e("div", {
    staticClass: "btn text-light p-2 cursor-default",
    class: `btn-${t.confirmationAlertStyle}`
  }, [e("FaSolidEye", {
    staticClass: "fa-lg"
  })], 1)]), t._m(0), !t.etapeToken && !t.etapeValidation ? e("div", {
    staticClass: "col-xl-1 col-1"
  }, [t.confirmationAccord ? e("div", {
    staticClass: "p-2 icone_tools float-end cursor-pointer",
    attrs: {
      id: "btn_confirmationAccord"
    },
    on: {
      click: function(i) {
        return t.confirmerAccord(!1);
      }
    }
  }, [e("FaRegularCheckSquare", {
    staticClass: "fa-lg"
  })], 1) : e("div", {
    staticClass: "p-2 icone_tools float-end cursor-pointer",
    attrs: {
      id: "btn_confirmationAccord"
    },
    on: {
      click: function(i) {
        return t.confirmerAccord(!0);
      }
    }
  }, [e("FaRegularSquare", {
    staticClass: "fa-lg"
  })], 1)]) : e("div", {
    staticClass: "col-xl-1 col-1"
  }, [t.confirmationAccord ? e("div", {
    staticClass: "p-2 icone_tools float-end",
    attrs: {
      id: "btn_confirmationAccord"
    }
  }, [e("FaRegularCheckSquare", {
    staticClass: "fa-lg"
  })], 1) : t._e()])])]), t.confirmationAccord ? t._e() : e("button", {
    staticClass: "btn btn-sm btn-light rounded-pill text-secondary me-2 w-100",
    attrs: {
      id: "btn_annuler_signature",
      type: "button"
    },
    on: {
      click: function(i) {
        return t.$emit("back");
      }
    }
  }, [t._v(" Annuler ")])]) : t._e(), t.user && !t.user.has_certificate ? e("div", [t.withConfirmationAccord && t.confirmationAccord || !t.withConfirmationAccord ? e("div", {
    attrs: {
      id: "bloc_signature"
    }
  }, [t.etapeDessin ? e("div", [e("h5", {
    staticClass: "text-center libelle_etape_signature"
  }, [t._v(" Étape 1 : Dessiner votre signature ")]), e("VueSignaturePad", {
    ref: "signaturePad",
    attrs: {
      id: "signaturePad",
      width: "20rem",
      height: "8rem",
      scaleToDevicePixelRatio: !1
    }
  }), t._m(1), e("div", {
    staticClass: "mt-2 text-center"
  }, [e("button", {
    staticClass: "btn btn-sm btn-light rounded-pill text-secondary me-2",
    attrs: {
      id: "btn_annuler_signature",
      type: "button"
    },
    on: {
      click: function(i) {
        return t.$emit("back");
      }
    }
  }, [t._v(" Annuler ")]), e("button", {
    staticClass: "btn btn-sm btn-info rounded-pill text-light me-2",
    attrs: {
      id: "btn_effacer_signature",
      type: "button",
      title: "Effacer"
    },
    on: {
      click: t.clearSignature
    }
  }, [e("FaSolidEraser", {
    staticClass: "fa-lg"
  })], 1), e("button", {
    staticClass: "btn btn-sm btn-primary rounded-pill text-light",
    attrs: {
      disabled: t.disabledButton,
      id: "btn_valider_signature",
      type: "button"
    },
    on: {
      click: t.saveSignature
    }
  }, [t._v(" Valider ")])])], 1) : t._e(), t.etapeSelectionSupport ? e("div", {
    staticClass: "text-center"
  }, [e("h5", {
    staticClass: "mb-2 pb-0 libelle_etape_signature"
  }, [t._v(" Étape 2 : Mode de réception du code d'authentification ")]), t.typeToken && t.typeToken.length > 1 ? e("p", {
    staticClass: "infos_reception"
  }, [t._v(" Comment souhaitez-vous recevoir le code d'authentification ? ")]) : t._e(), e("div", [t.withTokenSMS && (!t.typeToken || t.typeToken.length === 0 || t.typeToken.includes("sms") && t.typeToken.includes("mail")) ? e("div", {
    staticClass: "form-check form-check-inline"
  }, [e("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.mode_reception,
      expression: "mode_reception"
    }],
    staticClass: "form-check-input",
    attrs: {
      type: "radio",
      name: "mode_reception",
      id: "option_sms",
      value: "option_sms"
    },
    domProps: {
      checked: t._q(t.mode_reception, "option_sms")
    },
    on: {
      change: function(i) {
        t.mode_reception = "option_sms";
      }
    }
  }), e("label", {
    staticClass: "form-check-label",
    attrs: {
      for: "option_sms"
    }
  }, [t._v("par SMS")])]) : t._e(), t.withTokenSMS && (!t.typeToken || t.typeToken.length === 0 || t.typeToken.includes("sms") && t.typeToken.includes("mail")) ? e("div", {
    staticClass: "form-check form-check-inline"
  }, [e("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.mode_reception,
      expression: "mode_reception"
    }],
    staticClass: "form-check-input",
    attrs: {
      type: "radio",
      name: "mode_reception",
      id: "option_email",
      value: "option_email"
    },
    domProps: {
      checked: t._q(t.mode_reception, "option_email")
    },
    on: {
      change: function(i) {
        t.mode_reception = "option_email";
      }
    }
  }), e("label", {
    staticClass: "form-check-label",
    attrs: {
      for: "option_email"
    }
  }, [t._v("par Courriel")])]) : t._e(), t.mode_reception === "option_sms" && t.user && t.user.telephone && t.user.telephone !== void 0 ? e("div", {
    attrs: {
      id: "bloc_confirmerTelephone"
    }
  }, [e("div", {
    staticClass: "alert alert-primary ps-2 pt-2 pb-1 mb-3"
  }, [t._m(2), e("div", {
    staticClass: "text-center pb-4"
  }, [e("h6", {
    staticClass: "subtitle3 fw-bolder pt-0 pb-2"
  }, [t._v(" Voici le numéro qui sera utilisé : ")]), e("div", {
    staticClass: "d-inline fw-bolder bg-light text-primary py-2 px-3 mx-auto rounded-3"
  }, [t._v(" " + t._s(t.user.telephone) + " ")])]), e("div", {
    staticClass: "row px-3 lh-sm manque_tel_precisions"
  }, [t.checkHasDossierAdministratif() ? e("p", [t._v(" Si ce numéro n'est pas à jour, pour vous permettre de modifier votre numéro de téléphone sur votre dossier administratif, nous vous invitons à contacter le concours. ")]) : e("p", [t._v(" Si ce numéro n'est pas à jour, nous vous invitons à le modifier via l'édition de votre profil depuis le menu de profil / Profil. ")])])]), e("div", {
    staticClass: "text-center"
  }, [e("button", {
    staticClass: "btn btn-sm rounded-pill btn-primary text-light mb-2 ms-0 me-0",
    attrs: {
      id: "btn_confirmer_choix"
    },
    on: {
      click: t.confirmerModeReception
    }
  }, [t._v(" Suivant ")])])]) : t.mode_reception === "option_sms" ? e("div", [e("div", {
    staticClass: "mb-4",
    attrs: {
      id: "bloc_manqueTelephone"
    }
  }, [e("div", {
    staticClass: "alert alert-danger ps-2 pt-2 pb-1 mb-3"
  }, [t._m(3), e("div", {
    staticClass: "row px-3 lh-sm manque_tel_precisions"
  }, [t.checkHasDossierAdministratif() ? e("p", [t._v(" Pour vous permettre d'ajouter votre numéro de téléphone à votre dossier administratif, nous vous invitons à contacter le concours. ")]) : e("p", [t._v(" Vous pouvez renseigner votre numéro de téléphone via l'édition de votre profil depuis le menu de profil / Profil. ")])])])])]) : t._e(), t.mode_reception === "option_email" ? e("div", {
    attrs: {
      id: "bloc_confirmerEmail"
    }
  }, [e("div", {
    staticClass: "alert alert-primary ps-2 pt-2 pb-1 mb-3"
  }, [t._m(4), e("div", {
    staticClass: "text-center pb-4"
  }, [e("h6", {
    staticClass: "subtitle3 fw-bolder pt-0 pb-2"
  }, [t._v(" Voici l'adresse de courriel qui sera utilisée : ")]), e("div", {
    staticClass: "d-inline fw-bolder bg-light text-primary py-2 px-3 mx-auto rounded-3"
  }, [t._v(" " + t._s(t.user.email) + " ")])])]), e("div", {
    staticClass: "text-center"
  }, [e("button", {
    staticClass: "btn btn-sm rounded-pill btn-primary text-light mb-2 ms-0 me-0",
    attrs: {
      id: "btn_confirmer_choix"
    },
    on: {
      click: t.confirmerModeReception
    }
  }, [t._v(" Suivant ")])])]) : t._e()])]) : t._e(), t.etapeToken ? e("div", [e("h5", {
    staticClass: "text-center mb-0 pb-0 libelle_etape_signature"
  }, [t._v(" Étape 3 : Authentification de la signature ")]), t.mode_reception === "option_sms" ? e("p", {
    staticClass: "text-center mb-4 pt-2"
  }, [t._v(" Un code a été envoyé au "), e("strong", [t._v(t._s(t.user.telephone))])]) : t._e(), t.mode_reception === "option_email" ? e("p", {
    staticClass: "text-center mb-2 pt-2"
  }, [t._v(" Un code a été envoyé sur l'adresse "), e("strong", [t._v(t._s(t.user.email))])]) : t._e(), e("p", {
    staticClass: "text-center mb-4 pt-1 text-info font_medium"
  }, [t._v(" Attention, ce code n'est valable que 5 minutes. Passé ce délai, vous devrez recommencer le processus de signature. ")]), e("div", {
    staticClass: "ms-5 me-5 text-start"
  }, [e("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.tokenSMS,
      expression: "tokenSMS"
    }],
    staticClass: "form-control",
    attrs: {
      id: "input_token",
      type: "text",
      placeholder: "Saisissez le code reçu"
    },
    domProps: {
      value: t.tokenSMS
    },
    on: {
      input: function(i) {
        i.target.composing || (t.tokenSMS = i.target.value);
      }
    }
  })]), e("div", {
    staticClass: "mt-3 text-center"
  }, [e("button", {
    staticClass: "btn btn-sm btn-light rounded-pill text-secondary me-2",
    attrs: {
      id: "btn_annuler_token",
      type: "button"
    },
    on: {
      click: function(i) {
        return t.$emit("back");
      }
    }
  }, [t._v(" Annuler ")]), e("button", {
    staticClass: "btn btn-sm btn-primary rounded-pill text-light",
    attrs: {
      disabled: t.disabledButton,
      id: "btn_valider_token",
      type: "button"
    },
    on: {
      click: t.saveWithToken
    }
  }, [t._v(" Valider ")])])]) : t._e(), t.etapeValidation ? e("div", [e("h5", {
    staticClass: "text-center mb-4 libelle_etape_signature"
  }, [t._v(" Étape 4 : Validation de la signature ")]), t._m(5), e("div", {
    staticClass: "mt-3 text-center"
  }, [e("button", {
    staticClass: "btn btn-sm btn-light rounded-pill text-secondary me-2",
    attrs: {
      type: "button"
    },
    on: {
      click: function(i) {
        return t.$emit("back");
      }
    }
  }, [t._v(" Annuler ")]), e("button", {
    staticClass: "btn btn-sm btn-primary rounded-pill text-light",
    attrs: {
      disabled: t.disabledButton,
      type: "button"
    },
    on: {
      click: t.validationContrat
    }
  }, [t._v(" Confirmer ")])])]) : t._e()]) : t._e()]) : t._e(), t.user && t.user.has_certificate ? e("div", [e("h5", {
    staticClass: "text-center mb-4"
  }, [t._v("Signature électronique avec certificat")]), t._m(6), e("div", {
    staticClass: "mt-3 text-center"
  }, [e("button", {
    staticClass: "btn btn-sm btn-light rounded-pill text-secondary me-2",
    attrs: {
      type: "button"
    },
    on: {
      click: function(i) {
        return t.$emit("back");
      }
    }
  }, [t._v(" Annuler ")]), e("button", {
    staticClass: "btn btn-sm btn-primary rounded-pill text-light",
    attrs: {
      disabled: t.disabledButton,
      type: "button"
    },
    on: {
      click: t.signatureCertificat
    }
  }, [t._v(" Signer ")])])]) : t._e()]);
}, Be = [function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "col-xl-9 col-9"
  }, [e("h6", {
    staticClass: "libelle_etape ms-3 mb-0 subtitle3 fw-bolder"
  }, [t._v(" J'ai lu le document complet et j'en accepte les termes ")])]);
}, function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "form-check mt-2 mb-2",
    attrs: {
      hidden: ""
    }
  }, [e("input", {
    staticClass: "form-check-input ms-0 me-2 float-none",
    attrs: {
      type: "checkbox",
      value: "1",
      id: "flexCheckDefault"
    }
  }), e("label", {
    staticClass: "form-check-label text-muted",
    attrs: {
      for: "flexCheckDefault"
    }
  }, [t._v(" Enregistrer cette signature ")])]);
}, function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "pb-2"
  }, [e("h6", {
    staticClass: "libelle_etape ms-3 subtitle3 fw-bolder pt-0"
  }, [t._v(" Ce mode de signature requiert un numéro de téléphone. ")])]);
}, function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "pb-2"
  }, [e("h6", {
    staticClass: "libelle_etape ms-3 subtitle3 fw-bolder pt-0"
  }, [t._v(" Votre compte n'a pas de numéro de téléphone associé. Vous ne pouvez pas recevoir de SMS. ")])]);
}, function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "pb-2"
  }, [e("h6", {
    staticClass: "libelle_etape ms-3 subtitle3 fw-bolder pt-0"
  }, [t._v(" Ce mode de signature requiert une adresse de courriel. ")])]);
}, function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "ms-3 me-3 text-center"
  }, [t._v(" La procédure de signature va être finalisée. "), e("br"), t._v("Il ne sera plus possible de modifier le contrat."), e("br"), t._v(" Confirmez-vous l'envoi du contrat ? ")]);
}, function() {
  var t = this, n = t.$createElement, e = t._self._c || n;
  return e("div", {
    staticClass: "ms-3 me-3 text-center"
  }, [t._v(" Votre certificat numérique va être apposé sur le document. "), e("br"), t._v("Il ne sera plus possible de le modifier."), e("br"), t._v(" Confirmez-vous cette action ? ")]);
}];
const ht = {};
var We = /* @__PURE__ */ R(
  ze,
  Fe,
  Be,
  !1,
  Le,
  "022e64ca",
  null,
  null
);
function Le(t) {
  for (let n in ht)
    this[n] = ht[n];
}
const Ue = /* @__PURE__ */ function() {
  return We.exports;
}();
export {
  Ue as ExaSignature
};
